export default "__VITE_ASSET__CY4tehD5__"